import React from 'react';

import { ColorPalette } from 'types/constants';

import { Domain, Skill } from '@test_prep/app/ai_tutor/types';
import ColorPalettes from '@test_prep/app/ai_tutor/utilities/color_palettes';

interface IconProps {
  size: number;
}

export const ArrowIcon = (props: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.size} height={props.size} viewBox="0 0 18 18" fill="none">
      <title>An arrow icon</title>
      <path fill="currentColor" fillRule="evenodd" d="M10.93 4.472a1.042 1.042 0 0 1 1.473 0l4.792 4.792a1.042 1.042 0 0 1 0 1.473l-4.792 4.791a1.042 1.042 0 1 1-1.473-1.473l3.014-3.013H3.542a1.042 1.042 0 0 1 0-2.084h10.402L10.93 5.945a1.042 1.042 0 0 1 0-1.473Z" clipRule="evenodd" />
    </svg>
  );
};

export const BubbleAnnotationIcon = (props: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.size} height={props.size} viewBox="0 0 24 24" fill="none">
      <path fill="currentColor" fillRule="evenodd" d="M12 3c3.101 0 5.727.805 7.591 2.366C21.471 6.941 22.5 9.223 22.5 12s-1.03 5.059-2.909 6.634C17.727 20.194 15.101 21 12 21c-1.693 0-3.57-.162-5.234-.922a6.967 6.967 0 0 1-1.223.568c-.941.328-2.282.548-3.615-.086a.75.75 0 0 1-.277-1.129c1.443-1.912 1.015-3.08.997-3.13l-.006-.014-.008-.019-.012-.028c-.076-.183-.351-.859-.608-1.665-.25-.782-.514-1.78-.514-2.575 0-2.777 1.03-5.059 2.909-6.634C6.273 3.806 8.899 3 12 3Zm-5.5 9a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm4.5 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm5.5 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" clipRule="evenodd" />
    </svg>
  );
};

export const BubbleQuestionIcon = (props: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.size} height={props.size} viewBox="0 0 24 24" fill="none">
      <path fill="currentColor" fillRule="evenodd" d="M3 5.75A2.75 2.75 0 0 1 5.75 3h12.5A2.75 2.75 0 0 1 21 5.75v10.5A2.75 2.75 0 0 1 18.25 19h-2.874a.25.25 0 0 0-.16.058l-2.098 1.738a1.75 1.75 0 0 1-2.24-.007l-2.066-1.73a.25.25 0 0 0-.16-.059H5.75A2.75 2.75 0 0 1 3 16.25V5.75Zm6.874 3.678c0-1.244 1-2.265 2.25-2.265s2.25 1.02 2.25 2.265c0 .997-.65 1.52-1.07 1.806a1.424 1.424 0 0 0-.354.32 1.01 1.01 0 0 0-.186.47.75.75 0 1 1-1.484-.222c.145-.96.704-1.485 1.18-1.809.164-.111.265-.199.328-.284a.436.436 0 0 0 .086-.281.757.757 0 0 0-.75-.765.757.757 0 0 0-.75.765.75.75 0 0 1-1.5 0ZM12 15.25a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" clipRule="evenodd" />
    </svg>
  );
};

export const CrossIcon = (props: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.size} height={props.size} viewBox="0 0 16 16" fill="none">
      <title>A close icon</title>
      <path stroke="currentColor" strokeLinecap="round" strokeWidth="2.5" d="m3 3 9.667 9.667m0-9.667L3 12.667" />
    </svg>
  );
};

export const GraduateCapIcon = (props: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.size} height={props.size} viewBox="0 0 24 24" fill="none">
      <path fill="currentColor" d="M12.317 3.07a.75.75 0 0 0-.634 0L.433 8.327a.751.751 0 0 0 0 1.361l11.25 5.256a.749.749 0 0 0 .634 0L22.5 10.188v5.078a.75.75 0 1 0 1.5 0V9.007a.751.751 0 0 0-.433-.68L12.317 3.07Z" />
      <path fill="currentColor" fillRule="evenodd" d="M4.5 12.742v3.512c0 .654.364 1.253.943 1.554l5.75 2.994a1.748 1.748 0 0 0 1.614 0l5.75-2.994c.58-.301.943-.9.943-1.554v-3.512l-7.042 3.629a.999.999 0 0 1-.915 0L4.5 12.74Z" clipRule="evenodd" />
    </svg>
  );
};

export const PageTextSearchIcon = (props: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.size} height={props.size} viewBox="0 0 24 24" fill="none">
      <path fill="currentColor" fillRule="evenodd" d="M4 4.75A2.75 2.75 0 0 1 6.75 2h10.5A2.75 2.75 0 0 1 20 4.75v7.876A6 6 0 0 0 12.531 22H6.75A2.75 2.75 0 0 1 4 19.25V4.75Zm3 1A.75.75 0 0 1 7.75 5h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 7 5.75Zm0 4A.75.75 0 0 1 7.75 9h3.5a.75.75 0 0 1 0 1.5h-3.5A.75.75 0 0 1 7 9.75Z" clipRule="evenodd" />
      <path fill="currentColor" fillRule="evenodd" d="M16.5 13a4.5 4.5 0 1 0 2.623 8.157l.838.865a.75.75 0 1 0 1.078-1.044l-.86-.887A4.5 4.5 0 0 0 16.5 13Zm-3 4.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z" clipRule="evenodd" />
    </svg>
  );
};

export const TargetIcon = (props: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.size} height={props.size} viewBox="0 0 24 24" fill="none">
      <path fill="currentColor" d="m12.593 23.257-.01.002-.072.035-.02.005-.014-.005-.07-.035c-.011-.003-.02-.001-.025.005l-.004.01-.017.428.005.02.01.013.104.074.015.004.012-.004.104-.074.012-.016.004-.017-.017-.427c-.002-.01-.008-.016-.017-.018Zm.265-.113-.013.002-.185.093-.01.01-.003.012.018.43.005.011.008.007.201.093c.013.004.023.001.03-.008l.003-.014-.034-.614c-.003-.012-.01-.019-.02-.021Zm-.715.002a.02.02 0 0 0-.014-.002.02.02 0 0 0-.013.009l-.006.014-.034.613c0 .012.006.02.017.024l.015-.002.201-.093.01-.008.004-.01.017-.43-.003-.012-.01-.01-.184-.093ZM12 2c.896 0 1.764.118 2.59.339l-2.126 2.125A2.997 2.997 0 0 0 12.04 5H12a7 7 0 1 0 7 7v-.04a2.97 2.97 0 0 0 .535-.425l2.127-2.125c.22.826.338 1.694.338 2.59 0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm-.414 5.017c0 .85-.042 1.714.005 2.564l-.54.54a1.998 1.998 0 0 0 0 2.829 2 2 0 0 0 2.829 0l.54-.54c.85.046 1.711.004 2.563.004a5 5 0 1 1-5.397-5.397Zm6.918-4.89a1 1 0 0 1 .617.923v1.83h1.83a1 1 0 0 1 .706 1.707L18.12 10.12a1 1 0 0 1-.707.293h-2.412l-1.829 1.829a1 1 0 0 1-1.415-1.415L13.588 9V6.586a1 1 0 0 1 .293-.708l3.534-3.535a1 1 0 0 1 1.09-.217" />
    </svg>
  );
};

export const colorPaletteForSkill = (domain: Domain, skill: Skill) => {
  switch(skill?.klass || domain.klass) {
    case 'TestPrep::AI::TutoringSessions::Skills::PromptExplanation':
      return ColorPalettes.green;
    case 'TestPrep::AI::TutoringSessions::Skills::SimilarQuestion':
      return ColorPalettes.magenta;
    case 'TestPrep::AI::TutoringSessions::Domains::Tutor':
      return ColorPalettes.orange;
    case 'TestPrep::AI::TutoringSessions::Domains::CustomerSupport':
      return ColorPalettes.blue;
    default:
      return ColorPalettes.gray;
  };
};


export const iconForSkill = (domain: Domain, skill: Skill) => {
  switch(skill?.klass || domain.klass) {
    case 'TestPrep::AI::TutoringSessions::Skills::PromptExplanation':
      return PageTextSearchIcon;
    case 'TestPrep::AI::TutoringSessions::Skills::SimilarQuestion':
      return TargetIcon;
    case 'TestPrep::AI::TutoringSessions::Domains::Tutor':
      return GraduateCapIcon;
    case 'TestPrep::AI::TutoringSessions::Domains::CustomerSupport':
      return BubbleAnnotationIcon;
    default:
      return BubbleQuestionIcon;
  };
};

interface ActivityIconProps {
  colorPalette: ColorPalette;
}

export const ActivityIcon = (props: ActivityIconProps) => {
  return (
    <div
      className="align-items-center d-flex justify-content-center"
      style={{
        backgroundColor: props.colorPalette.light,
        border: '1px solid rgba(28, 28, 28, 0.05)',
        borderRadius: '50%',
        color: props.colorPalette.dark,
        height: 24,
        width: 24
      }}
    >
      <TargetIcon size={14} />
    </div>
  );
};

interface SkillIconProps {
  domain: Domain;
  size: 'sm' | 'lg';
  skill: Skill;
}

export const SkillIcon = (props: SkillIconProps) => {
  const size = props.size === 'sm' ? 24 : 40;

  let colorPalette = colorPaletteForSkill(props.domain, props.skill);
  const Icon = iconForSkill(props.domain, props.skill);

  return (
    <div
      className="align-items-center d-flex justify-content-center"
      style={{
        backgroundColor: colorPalette.light,
        border: '1px solid rgba(28, 28, 28, 0.05)',
        borderRadius: '50%',
        color: colorPalette.dark,
        height: size,
        width: size
      }}
    >
      <Icon size={props.size === 'sm' ? 14 : 24} />
    </div>
  );
};
